<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="carSizeObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>

            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">{{ title }}</p>
                    <p>Trigger when the vehicle size is above:
                        <span class="rule-config-variable" @click="isEdit = !isEdit">
                            {{ $helpers.getCarSizeName(carSizeObj.value) }}
                            <b-icon icon="pencil" size="is-small"></b-icon>
                        </span>
                    </p>
                </div>
                <div class="allbtns">
                    <b-switch :rounded="true" :value="carSizeObj.isActive" v-model="carSizeObj.isActive"
                        @input="carSizeGreaterThan" :left-label="true">{{ carSizeObj.isActive ? 'Active' : 'Inactive' }}
                    </b-switch>
                </div>
            </div>
        </div>
        <div v-if="isEdit" class="edittravelpolicy">
            <CarSize @carSize="getValue" :carsizeis="carSizeObj.value" />
            <p>Select car size</p>
            <b-button @click="saveCall">SAVE</b-button>
        </div>
        <StandardRuleActions v-if="carSizeObj.isActive && !isEdit" :ruleObj="carSizeObj" :title="title"
            @save="updateActions" />
    </div>
</template>
<script>
import CarSize from '../CommonRules/CarSize.vue';
import StandardRuleActions from "../StandardRuleActions.vue";
export default {
    name: "",
    props: {
        value: {
            type: [Object],
        },
    },
    components: {
        CarSize,
        StandardRuleActions
    },
    data() {
        return {
            carSizeObj: this.value ? this.value : {
                name: "carSizeGreaterThan",
                isActive: false,
                value: 'I',
                type: 'car',
                message: '',
            },
            isEdit: false,
            emitedValue: null,
            title: "Car size"
        }
    },
    methods: {
        saveCall() {
            this.isEdit = false;
            if (this.emitedValue || this.emitedValue == '') {
                this.carSizeObj.value = this.emitedValue;
            }
            this.buildMessage();
        },
        getValue(val) {
            this.emitedValue = val;
        },
        carSizeGreaterThan() {
            if (!this.carSizeObj.isActive) {
                // Clear the custom action parameters when deactivating
                this.clearActionParams();
            } else {
                // Rebuild message when activating
                this.buildMessage();
            }

            this.emitRuleObj();
        },
        buildMessage() {

            var string = 'Trigger when the vehicle size is above ';

            this.carSizeObj.message = string + this.carSizeObj.value;
        },
        emitRuleObj() {
            this.$emit('carSizeGreaterThan', this.carSizeObj)
        },
        clearActionParams() {
            // Reset to default actions when rule is not active ()
            this.carSizeObj.useCustomActions = false;
            delete this.carSizeObj.visibility;
            delete this.carSizeObj.approvalLevel;
            delete this.carSizeObj.notifications;
        },
        updateActions(updatedRule) {
            // Merge the updated properties into carSizeObj
            this.carSizeObj = { ...this.carSizeObj, ...updatedRule };

            // If useCustomActions is false, delete the associated properties
            if (!updatedRule.useCustomActions) {
                this.clearActionParams();
            }

            this.buildMessage();

            this.emitRuleObj();
        },
    },
    mounted() {
        this.carSizeObj.type = 'car';

        this.emitRuleObj();
    },
    watch: {
        value: {
            handler(newVal, prevVal) {
                this.carSizeObj = this.value;
                this.carSizeObj.type = 'car';
                this.buildMessage();
                this.emitRuleObj();

            },
            deep: true,
        },
    },
}
</script>